<app-vertical-menu-options [items]="menuItems" ariaLabel="Actions" (itemClicked)="onAction($event)"></app-vertical-menu-options>
